import { createContext, useContext, useCallback } from 'react';
import { MODULES, type ModuleId } from './catalog';

/** Isolated components retain the full product; main.tsx always installs the server policy. */
export const ModuleContext = createContext<readonly ModuleId[]>(Object.keys(MODULES) as ModuleId[]);

export function useModules() {
  const modules = useContext(ModuleContext);
  return useCallback((module: ModuleId): boolean => modules.includes(module), [modules]);
}
